import React, { useMemo } from 'react';
import { useLocalStorage } from './useLocalStorage';

const TopBar = ({ routine, title, onOpenSettings, onReset }) => {

  const [streak] = useLocalStorage('morningMissionStreak', 0); 
  const subtitle = useMemo(() => {
    const streakText = streak > 0 ? ` · Streak: ${streak}` : '';
    const taskCountText = `${routine.tasks.length} opgaver i gang`;
    return `${taskCountText}${streakText}`;
  }, [routine.tasks.length, streak]);

  return (
    <div className="topbar">
      <div className="brand">
        <h1 id="title">{title}</h1>
        <div className="sub" id="subtitle">
          {subtitle}
        </div>
      </div>
      <div className="top-actions">
        <button className="icon-btn secondary" onClick={onOpenSettings}>
          ⚙️
        </button>
        <button className="icon-btn" onClick={onReset}>
          ↺
        </button>
      </div>
    </div>
  );
};

export default TopBar;
